<template>
  <div class="monitor-container">
    <!-- 关键词输入框区域 -->
    <div class="input-section">
      <label class="input-label" for="keyword">输入监控关键词</label>
      <input
        type="text"
        id="keyword"
        class="keyword-input"
        v-model="monitorKeyword"
        placeholder="请输入需要监控的关键词"
      >
    </div>

    <!-- 复选框组区域 -->
    <div class="checkbox-section">
      <div class="input-label">选择监控类型</div>
      <div class="checkbox-group">
        <label class="checkbox-item" v-for="item in monitorTypes" :key="item.id">
          <input type="checkbox" :value="item.name" v-model="selectedTypes">
          {{ item.name }}
        </label>
      </div>
    </div>

    <!-- 底部提示文本 -->
    <div class="tips-section">
      实时监控互联网数据，当有符合监控条件的数据时，推送到你的电脑和手机进行提醒。
    </div>
  </div>
</template>

<script>
import {Field, Tab, Tabs, Checkbox, CheckboxGroup, RadioGroup, Radio, Button, Divider, Overlay, DropdownMenu, DropdownItem, Row, Col} from 'vant';

export default {
components: {
  [Field.name]: Field,
  [Tabs.name]: Tabs,
  [Tab.name]: Tab,
  [CheckboxGroup.name]: CheckboxGroup,
  [Checkbox.name]: Checkbox,
  [RadioGroup.name]: RadioGroup,
  [Radio.name]: Radio,
  [Button.name]: Button,
  [Divider.name]: Divider,
  [Overlay.name]: Overlay,
  [DropdownMenu.name]: DropdownMenu,
  [DropdownItem.name]: DropdownItem,
  [Row.name]: Row,
  [Col.name]: Col,
},
data() {
  return {
    // 监控关键词
    monitorKeyword: '',
    // 监控类型列表
    monitorTypes: [
      {id: 1, name: '监控公某号'},
      {id: 2, name: '监控互动问答'},
      {id: 3, name: '监控新增概念名称'},
      {id: 4, name: '监控某论坛帖子或发帖人'},
      {id: 5, name: '监控自定义网站'}
    ],
    // 已选中的监控类型
    selectedTypes: []
    }
  }
};
</script>

<style>
  /* 全局样式重置 */
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-family: "Microsoft YaHei", sans-serif;
  }

  /* 页面容器样式 */
  .monitor-container {
    max-width: 600px;
    margin: 50px auto;
    padding: 30px;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  }

  /* 输入框区域样式 */
  .input-section {
    margin-bottom: 10px;
  }

  .input-label {
    display: block;
    margin-bottom: 8px;
    font-size: 14px;
    color: #333;
    font-weight: 500;
  }

  .keyword-input {
    width: 100%;
    height: 40px;
    padding: 0 12px;
    border: 1px solid #d1d5db;
    border-radius: 4px;
    font-size: 14px;
    outline: none;
    transition: border-color 0.2s;
  }

  .keyword-input:focus {
    border-color: #3b82f6;
    box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.1);
  }

  /* 复选框区域样式 */
  .checkbox-section {
    margin-bottom: 10px;
  }

  .checkbox-group {
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin-top: 10px;
  }

  .checkbox-item {
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #4b5563;
  }

  .checkbox-item input {
    width: 16px;
    height: 16px;
    margin-right: 8px;
    cursor: pointer;
  }

  /* 底部提示文本样式 */
  .tips-section {
    padding-top: 10px;
    border-top: 1px solid #f3f4f6;
    font-size: 13px;
    color: #6b7280;
    line-height: 1.6;
  }
</style>